// src/components/adminComponents/taxSettings/taxSettingsList.jsx
import React, { Component } from 'react';
import TmReactTable from '../../utilComponents/tmReactTable/tmReactTable';
import moment from 'moment';
import TmExportExcel from '../../utilComponents/tmExportExcel/tmExportExcel';

class TaxSettingsList extends Component {
  constructor() {
    super();
    this.state = {
      excelDataSet: []
    };
    this.buildDataFormatForExport = this.buildDataFormatForExport.bind(this);
  }

  componentWillReceiveProps = (nextProps) => {
    this.setState({ excelDataSet: nextProps.taxSettings.chargeTaxSettings });
  }

  buildDataFormatForExport = () => {
    return ([{
      columns: [
        { title: 'Charge Name' }, 
        { title: 'Taxable' }, 
        { title: 'Tax Rate (%)' }
      ],
      data: this.state.excelDataSet.map((item) => {
        return [
          { value: item.chargeName },
          { value: item.isTaxable ? 'Yes' : 'No' },
          { value: item.taxRate }
        ]
      })
    }])
  }

  render() {
    const { 
      taxSettings, 
      onUpdateDefaultRate, 
      onToggleTaxable, 
      onUpdateTaxRate, 
      onApplyToAll, 
      onSave,
      accessLevel 
    } = this.props;

    // Split charges into DEFAULT and CUSTOM groups
    const defaultCharges = taxSettings.chargeTaxSettings.filter(charge => charge.global === true);
    const customCharges = taxSettings.chargeTaxSettings.filter(charge => charge.global === false);

    const columns = [
      {
        Header: 'Charge Name',
        accessor: 'chargeName',
        filterable: true,
        minWidth: 200
      },
      {
        Header: 'Taxable',
        accessor: 'isTaxable',
        filterable: true,
        minWidth: 100,
        style: { textAlign: 'center' },
        Filter: ({ filter, onChange }) =>
          <select className="form-control"
            onChange={event => onChange(event.target.value)}
            style={{ width: '100%' }}
            value={filter ? filter.value : ''}
          >
            <option value="">All</option>
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>,
        Cell: props => (
          <input
            type="checkbox"
            checked={props.value}
            onChange={() => onToggleTaxable(props.original.chargeListId)}
          />
        )
      },
      {
        Header: 'Percent',
        accessor: 'taxRate',
        filterable: true,
        minWidth: 150,
        Cell: props => (
          <input
            type="number"
            className="form-control"
            value={props.value}
            onChange={(e) => onUpdateTaxRate(props.original.chargeListId, e.target.value)}
            disabled={!props.original.isTaxable}
            step="0.1"
            min="0"
            max="100"
          />
        )
      }
    ];

    return (
      <>
        <div className="row">
          <div className="col-md-6 col-sm-12 mb-5 mt-2">
            <div className="form-group row">
              <label className="col-sm-4 col-form-label">Default Tax Rate (%)</label>
              <div className="col-sm-4">
                <input
                  type="number"
                  className="form-control"
                  value={taxSettings.companyTaxConfig.defaultTaxRate}
                  onChange={(e) => onUpdateDefaultRate(e.target.value)}
                  step="0.1"
                  min="0"
                  max="100"
                />
              </div>
              <div className="col-sm-4">
                <button
                  className="btn btn-primary"
                  onClick={onApplyToAll}
                >
                  Apply To All
                </button>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-sm-6 mb-5">
            <div className="pull-right">
              <div className="btn-list" style={{ display: 'inline-block' }}>
                <TmExportExcel
                  name={'Tax Settings'}
                  filename={`${"TaxSettings_"}${moment().format('MMDDYYhhmm')}`}
                  fileExtension={'xlsx'}
                  element={<button className="btn btn-warning btn-sm"><i className="fa fa-file-excel-o"></i> Export</button>}
                  dataSet={this.buildDataFormatForExport()}
                />
                {true ? (
                  <button className="btn btn-success btn-sm" onClick={onSave}>
                    <i className="fa fa-save"></i> Save
                  </button>
                ) : null}
              </div>
            </div>
          </div>
        </div>

        {/* DEFAULT CHARGES */}
        <div className="row">
          <div className="col-md-12 col-sm-12">
            <h5>DEFAULT CHARGES</h5>
          </div>
          <div className="col-md-12 col-sm-12 mb-20">
            <TmReactTable
              filterable
              sortable
              resizable
              defaultPageSize={5}
              data={defaultCharges}
              columns={columns}
              className="-striped -highlight"
            />
          </div>
        </div>

        {/* CUSTOM CHARGES */}
        <div className="row">
          <div className="col-md-12 col-sm-12">
            <h5>CUSTOM CHARGES</h5>
          </div>
          <div className="col-md-12 col-sm-12 mb-30">
            <TmReactTable
              ref={(table) => this.taxSettingsTable = table}
              onFilteredChange={() => {
                let data = this.taxSettingsTable.tmReactTable.getResolvedState().sortedData;
                this.setState({ excelDataSet: data });
              }}
              filterable
              sortable
              resizable
              defaultPageSize={10}
              data={customCharges}
              columns={columns}
              className="-striped -highlight"
            />
          </div>
        </div>
      </>
    );
  }
}

export default TaxSettingsList;